let listeners = [];
let state = { badgeIds: [], dailyDone: false, dailyLabel: '' };

function notify() {
  listeners.forEach(fn => fn(state));
}

export function subscribe(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
}

export function showAchievementPopup(badgeIds) {
  state = { ...state, badgeIds: [...new Set([...state.badgeIds, ...badgeIds])] };
  notify();
}

export function showDailyPopup(label) {
  state = { ...state, dailyDone: true, dailyLabel: label || 'Challenge' };
  notify();
}

export function dismissPopup(id) {
  if (id === 'daily') {
    state = { ...state, dailyDone: false, dailyLabel: '' };
  } else {
    state = { ...state, badgeIds: state.badgeIds.filter(b => b !== id) };
  }
  notify();
}

export function getState() {
  return state;
}
